export default {
  SET_PERIODS(state, periods) {
    state.periods = periods;
  },
  SET_PERIODS_COMBO(state, periodsCombo) {
    state.periodsCombo = periodsCombo;
  },
  SET_ALERT_REMOVE(state, status) {
    state.alertRemove = status;
  },
  SET_PERIOD(state, period) {
    state.period = period;
  },
  SET_OVERLAY(state, status) {
    state.overlay = status;
  }
};
